import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderSlot as _renderSlot, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card-border" }
const _hoisted_2 = { class: "content" }

import AccordionInfoDisplay from '@/components/features/info-display/AccordionInfoDisplay.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'AccordionCardInfoDisplay',
  props: {
    heading: { default: '' },
    isExpanded: { type: Boolean, default: false },
    leftIcon: { type: Boolean, default: false },
    subText: { default: '' },
    tabIndex: { default: 0 }
  },
  emits: ['onClicked'],
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AccordionInfoDisplay, {
      heading: _ctx.heading,
      isExpanded: _ctx.isExpanded,
      leftIcon: _ctx.leftIcon,
      subText: _ctx.subText,
      tabIndex: _ctx.tabIndex,
      onOnClicked: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClicked')))
    }, null, 8, ["heading", "isExpanded", "leftIcon", "subText", "tabIndex"]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "content")
    ], 512), [
      [_vShow, _ctx.isExpanded]
    ])
  ]))
}
}

})